'use client';
import { ProductJsonLd } from 'next-seo';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { ProductProps } from '../../types';

export interface ProductSeoProps {
  product?: ProductProps;
}

const ProductSeo = ({
  product: {
    title,
    description,
    shortDescription,
    sku,
    price,
    color,
    mainImageUrl,
    currency,
    ratingSummary,
    isOrderable,
  } = {} as any,
}: ProductSeoProps) => {
  const { path } = useCurrentUrl();

  if (!price || !title) return null;

  const available = isOrderable ? 'https://schema.org/InStock' : 'http://schema.org/OutOfStock';

  const url = `${process.env.NEXT_PUBLIC_WEB_ENV}/${path}`;

  return (
    <ProductJsonLd
      useAppDir
      scriptId="jsonld-product"
      productName={title ?? ''}
      images={[mainImageUrl ?? '']}
      description={description}
      brand="Traeger"
      color={color}
      disambiguatingDescription={shortDescription}
      aggregateRating={
        ratingSummary &&
        ratingSummary?.count !== 0 && {
          ratingValue: ratingSummary?.average,
          reviewCount: ratingSummary?.count,
        }
      }
      offers={[
        {
          price,
          priceCurrency: currency,
          availability: available,
          itemCondition: 'https://schema.org/NewCondition',
          url,
        },
      ]}
      mpn={sku}
      sku={sku}
    />
  );
};

export default ProductSeo;
